<template>
  <!-- MENU LATERAL -->
  <div class="menu-sidebar menu-sidebar-small">
    <ul class="menu-list">

      <li v-if="showLayers">
        <button class="btn" id="capas" name="capas" @click="clickItem('layers')" title="Capas">
          <i class="bi bi-layers"></i>
        </button>
      </li>
      <li v-if="showMapTypes">
        <button class="btn" id="mapa" name="mapa" @click="clickItem('mapa')" title="Tipo Mapa">
          <i class="bi bi-back"></i>
        </button>
      </li>

      <li v-if="showEvents">
        <button class="btn" id="event-1" name="event-1" @click="clickItem('events')" title="Eventos"
          :class="{ 'minimized': isModalMinimized('events') }">
          <i class="bi bi-bookmark-star"></i>
        </button>
      </li>

      <li v-if="showImages">
        <button class="btn" id="images" name="images" @click="clickItem('images')" title="Imágenes"
          :class="{ 'minimized': isModalMinimized('images') }">
          <i class="bi bi-images"></i>
        </button>
      </li>
      <li v-if="showMosaics">
        <button class="btn" id="mosaics" name="mosaics" @click="clickItem('mosaics')" title="Mosaicos"
          :class="{ 'minimized': isModalMinimized('mosaics') }">
          <i class="bi bi-puzzle"></i>
        </button>
      </li>
      <li v-if="showVideos">
        <button class="btn" id="video" name="video" @click="clickItem('videos')" title="Videos"
          :class="{ 'minimized': isModalMinimized('videos') }">
          <i class="bi bi-play-btn"></i>
        </button>
      </li>
      <li v-if="showOrders">
        <button class="btn" id="orders" name="orders" @click="clickItem('orders')" title="Órdenes de Misión"
          :class="{ 'minimized': isModalMinimized('orders') }">
          <i class="bi bi-file-binary"></i>
        </button>
      </li>
      <li v-if="showMissions">
        <button class="btn" id="missions" name="missions" @click="clickItem('missions')" title="Planes de Misión"
          :class="{ 'minimized': isModalMinimized('missions') }">
          <i class="bi bi-journal-text"></i>
        </button>
      </li>
      <li v-if="showReports">
        <button class="btn" id="reports" name="reports" @click="clickItem('reports')" title="Reportes"
          :class="{ 'minimized': isModalMinimized('reports') }">
          <i class="bi bi-files"></i>
        </button>
      </li>
    </ul>
  </div>
  <!-- FIN MENU LATERAL -->
</template>
<script setup lang="ts">
import API from "../services";
import { onMounted,ref } from "vue"

const showLayers = ref(false)
const showMapTypes = ref(false)
const showEvents = ref(false)
const showImages = ref(false)       
const showMosaics = ref(false)
const showVideos = ref(false)
const showOrders = ref(false)
const showMissions = ref(false)
const showReports = ref(false)

const props = defineProps<{
  minimizedModals: string[]
}>()
const emit = defineEmits<{
  (event: 'itemSelected', seleccionado: string): void
  (event: 'restoreModal', modalId: string): void
}>()
function isModalMinimized(modalId: string): boolean {
  return props.minimizedModals.includes(modalId)
}
function clickItem(seleccionado: string) {
  if (isModalMinimized(seleccionado)) {
    emit('restoreModal', seleccionado)
  } else {
    // Si no está minimizado, funciona como antes
    emit('itemSelected', seleccionado)
  }
}
onMounted(async () => {

  showLayers.value = await API.checkPermiso('SHOW_LAYERS')
  showMapTypes.value = await API.checkPermiso('SHOW_MAP_TYPES')
  showEvents.value = await API.checkPermiso('SHOW_EVENTS')
  showImages.value = await API.checkPermiso('SHOW_PHOTOS')
  showMosaics.value = await API.checkPermiso('SHOW_MOSAICS')
  showVideos.value = await API.checkPermiso('SHOW_VIDEOS')
  showOrders.value = await API.checkPermiso('SHOW_ORDERS')
  showMissions.value = await API.checkPermiso('SHOW_PLANS')
  showReports.value = await API.checkPermiso('SHOW_REPORTS')
})
</script>
<style scoped>
.open-window {
  background-color: #6c757d;
}

.minimized {
  background-color: rgb(91, 161, 223);
}


.minimized:hover {
  background-color: rgba(164, 213, 255, 0.8);
}

.btn:hover {
  background-color: rgba(255, 255, 255, 0.5);
}


@media (max-width: 680px) {
  .menu-sidebar-small {
    width: 30px;
  }

  .btn {
    padding: 0;
    width: 30px;
    height: 40px;
    font-size: 14px;
  }
}

@media (max-height: 400px) {
  .menu-sidebar-small {
    width: 30px;
    top: 30px;
  }

  .btn {
    padding: 0;
    width: 30px;
    height: 30px;
    font-size: 14px;
  }
}
</style>
